import ukFlag from "../assets/images/flags/uk1.png"
import spain from "../assets/images/flags/spain.jpg"
import germany from "../assets/images/flags/germany.jpg"
import italy from "../assets/images/flags/italy.jpg"
import russia from "../assets/images/flags/russia.jpg"

const languages = {

  en: {
    label: "English",
    flag: ukFlag,
  },
}

export default languages
